export default __webpack_public_path__ + "static/media/pub3.d26dea6f.png";